// extracted by mini-css-extract-plugin
module.exports = {"DataSelectorWrapper":"DataSelector_DataSelectorWrapper__2kffV"};